import * as tslib_1 from "tslib";
import axios from 'axios';
import { stringify } from 'qs';
var BaseSocialContentService = /** @class */ (function () {
    function BaseSocialContentService(serviceName, token, groupId, contextTokenRepository) {
        this.token = token;
        this.groupId = groupId;
        this.contextTokenRepository = contextTokenRepository;
        this.apiClient = axios.create({
            baseURL: "/social-content/api/v1/" + serviceName,
            headers: {
                Authorization: token,
            },
            paramsSerializer: function (params) { return stringify(params, { allowDots: true }); },
        });
        this.apiClient.interceptors.request.use(this.contextTokenInterceptor.bind(this));
    }
    BaseSocialContentService.prototype.contextTokenInterceptor = function (config) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var contextToken;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.contextTokenRepository.getContextToken(this.groupId)];
                    case 1:
                        contextToken = _a.sent();
                        config.params = tslib_1.__assign({ contextToken: contextToken }, config.params);
                        return [2 /*return*/, config];
                }
            });
        });
    };
    return BaseSocialContentService;
}());
export { BaseSocialContentService };
//# sourceMappingURL=base-social-content.service.js.map